/* Seramik House — sonsuz kaydirma (koleksiyon + arama urun listesi)
   Sayfa sonuna yaklasinca bir sonraki sayfayi section render'iyla ceker,
   urun kartlarini mevcut <product-list>'e ekler. Facet yenilemesinde
   bolum icerigi degistigi icin element yeniden baglanir ve guncel
   data-next-url ile devam eder. Hata olursa sentinel kendini kaldirir
   ve klasik sayfalama geri gorunur.
   Tetikleme: IntersectionObserver yerine throttle'li scroll/resize dinleyici —
   anlik atlamalarda (End tusu, çapa, programatik scroll) IO kacirabiliyor. */
(function () {
  if (window.customElements.get('sh-infinite-scroll')) return;

  var MARGIN = 1200; /* px — sentinel viewport'un bu kadar altindayken yukle */

  class SHInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this._nextUrl = this.getAttribute('data-next-url');
      this._loading = false;
      this._timer = null;
      /* klasik sayfalamayi gizle (JS yoksa gorunur kalir) */
      this._nav = this.parentElement && this.parentElement.querySelector('.collection__pagination');
      if (this._nav) this._nav.setAttribute('data-sh-hidden', '');
      this._onScroll = this._schedule.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      /* emniyet: scroll event'i gelmeyen webview'lerde de calissin */
      this._interval = setInterval(this._onScroll, 1000);
      this._schedule(); /* ilk sayfa viewport'u doldurmuyorsa hemen yukle */
    }

    disconnectedCallback() {
      this._teardown();
    }

    _teardown() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._interval) clearInterval(this._interval);
      if (this._timer) clearTimeout(this._timer);
      this._interval = null;
      this._timer = null;
    }

    _schedule() {
      /* rAF degil setTimeout: gizli/embedded sekmelerde rAF donar */
      if (this._timer || this._loading || !this._nextUrl) return;
      var self = this;
      this._timer = setTimeout(function () {
        self._timer = null;
        var vh = window.innerHeight || document.documentElement.clientHeight || 800;
        if (self.getBoundingClientRect().top < vh + MARGIN) {
          self._loadNext();
        }
      }, 100);
    }

    async _loadNext() {
      if (this._loading || !this._nextUrl) return;
      this._loading = true;
      this.setAttribute('loading', '');

      try {
        var sectionEl = this.closest('.shopify-section');
        var sectionId = sectionEl.id.replace('shopify-section-', '');
        var url = new URL(this._nextUrl, location.origin);
        url.searchParams.set('section_id', sectionId);

        var res = await fetch(url.toString());
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        var newList = doc.querySelector('product-list');
        var curList = sectionEl.querySelector('product-list');
        if (newList && curList) {
          var frag = document.createDocumentFragment();
          Array.from(newList.children).forEach(function (node) {
            /* promosyon bloklari her sayfada ayni id ile tekrar render edilir — kopyalari atla */
            if (node.id && document.getElementById(node.id)) return;
            frag.appendChild(node);
          });
          curList.appendChild(frag);
        }

        var nextEl = doc.querySelector('sh-infinite-scroll');
        this._nextUrl = nextEl ? nextEl.getAttribute('data-next-url') : null;
        if (!this._nextUrl) {
          this._teardown();
          this.setAttribute('done', '');
        }
      } catch (e) {
        this._teardown();
        if (this._nav) this._nav.removeAttribute('data-sh-hidden'); /* klasik sayfalama geri gelsin */
        this.remove();
        return;
      } finally {
        this._loading = false;
        this.removeAttribute('loading');
      }

      /* sentinel hala menzildeyse (kisa icerik / dipte bekleyen kullanici) zincirle */
      this._schedule();
    }
  }

  window.customElements.define('sh-infinite-scroll', SHInfiniteScroll);
})();
